import {ActionType} from '../../../actions/actions';
import AssociationsState from './AssociationsState';
import {AnyAction} from "redux";
import {DisplayFeature} from "../../contract-features-3/domain";

const InitialState = new AssociationsState();

const AssociationsReducers = (state = InitialState, action: AnyAction): AssociationsState =>  {
    console.info("%c >> " + ActionType[action.type] || 'INITIALIZING', 'color: #f0f');

    const actionType: ActionType = action.type;

    switch (actionType) {
        case ActionType.GO_HOME:
            return new AssociationsState();

        case ActionType.START_FETCHING:
            return state.withIsFetching(true);

        case ActionType.STOP_FETCHING:
            return state.withIsFetching(false);
        case ActionType.FETCH_DATACATALOG:
            return state.withDatacatalog(action.datacatalog);
        case ActionType.SELECT_CONTRACT:
            return state.withContractId(action.contractId);

        case ActionType.REQUEST_CONTRACT:
        case ActionType.RESOLVE_ISSUE:
        case ActionType.COPY_ATTRIBUTE_VALUE:
        case ActionType.FETCH_FEATURE_TYPE:
        case ActionType.EDIT_ATTRIBUTE:
        case ActionType.LOCK_FEATURE:
        case ActionType.SHOW_EXISTING_FEATURES:
            return state.withIsFetching(true);
        case ActionType.SET_FEATURES:
            return state.withFeatures(action.features);

        case ActionType.RECEIVE_CONTRACT:
            return state.withIsFetching(false)
                .withFeatureTypes(action.featureTypes);

        case ActionType.RECEIVE_USER:
            return state.withUser(action.user);


        case ActionType.SELECT_FEATURE_TYPE:
            return state
                .withSelectedFeatures([])
                .withSelectedFeatureTypeId(action.featureTypeId)
                .withIsShowingExistingFeatures(false)
                .withExistingFeatures([])
                .withAdditionalSelectedFeatureTypes([]);


        case ActionType.UNSELECT_FEATURE_TYPE:
            return state
                .withNoSelectedFeatureType();

        case ActionType.ASSOCIATIONS_RECEIVED:

            let associations = action.associatedFeatures;
            state = state
                .withAssociations(associations.featureTree)
                .withAssociationsFlat(associations.associations);
            // update the selected association
            if (state.selectedAssociation){
                state = state.withSelectedAssociation(state.associations.find(a => {
                    return a.id === state.selectedAssociation.id
                }))
            }
            return state;

        case ActionType.ASSOCIATIONS_SET_NVDB_FEATURE_TYPES:
            return state.withNvdbFeatureTypes(action.nvdbFeatureTypes);

        case ActionType.ASSOCIATION_SELECT:
            return state.withSelectedAssociation(action.selection)
                        .withSelectedSourceFeature(action.sourceFeature);

        case ActionType.ASSOCIATION_UNSELECT:
            return state.withUnselectAssociation();

        case ActionType.ASSOCIATIONS_RECEIVE_POTENTIAL_CHILDREN_TYPES:
            return state
                .withTargetAssociationTypes(action.targetAssociationTypes)

        case ActionType.ASSOCIATIONS_RECEIVE_POTENTIAL_CHILDREN:
            return state
                .withTargetFeatures(action.features);

        case ActionType.ASSOCIATIONS_CLEAR_POTENTIAL_CHILDREN:
            return state
                .withTargetFeatures([])
                .withSelectedTargetFeatures([]);

        case ActionType.RECEIVE_FEATURE_TYPE:
            return state
                .withIsFetching(false)
                .withSelectedFeatureType(action.featureType);

        case ActionType.UPDATE_ASSOCIATION_TARGETS:
            return state.withSelectedTargetFeatures(action.targets);

        case ActionType.ASSOCIATIONS_SELECT_TARGET_TYPE:
            return state.withSelectedAssociationTargetType(action.featureType);

        case ActionType.ASSOCIATIONS_SET_NVDB_MAX_SEARCH_DISTANCE:
            return state.withNvdbSearchDistance(action.nvdbSearchDistance);

        case ActionType.CHANGE_ACTIVE_TAB:
            return state.withTab(action.tab);

        case ActionType.ASSOCIATIONS_RECEIVE_ATTRIBUTE_POPOVER:
            return state.withAttributePopoverData(action.attributePopoverData);

        case ActionType.AUTOASSOCIATION_SET_FEEDBACK_TEXT:
            return state.withAutoAssociationFeedback(action.autoAssociateCount);

        case ActionType.ERROR:
            console.log('%c     GURU MEDITATION     ', 'background: #555; color: #F88; border: 1px solid #f88');
            console.log(action);
            return state;
        default:
            return state;
    }
};

export default AssociationsReducers;
